/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listEmploymentsForPos} from '../api'

export const useMutationListEmploymentsForPos = createReactQueryMutationHook('listEmploymentsForPos', listEmploymentsForPos)
